module.exports = __webpack_public_path__ + "static/img/background.a4d41a29.svg";